module.exports = __webpack_public_path__ + "static/media/shape_F.4a0e716c.glb";